import React, { useState, useEffect } from 'react';
import { CrudForm, CrudStyles } from '../shared/Crud';
import MessageModal from '../shared/MessageModal';

const { FormGroup, FormRow, Input, Select } = CrudStyles;

const VEHICLE_TYPES = [
    { value: 'TRUCK', label: 'Caminhão' },
    { value: 'VAN', label: 'Van' },
    { value: 'BUS', label: 'Ônibus' },
    { value: 'CAR', label: 'Carro' },
    { value: 'MOTORCYCLE', label: 'Moto' },
];

export default function VehicleForm({ initialData, onSubmit, onCancel }) {
    const [formData, setFormData] = useState({
        licensePlate: '',
        brand: '',
        model: '',
        year: new Date().getFullYear(),
        color: '',
        chassis: '',
        type: 'CAR',
    });
    const [errors, setErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [messageModal, setMessageModal] = useState({ open: false, title: 'Aviso', message: '' });

    useEffect(() => {
        if (initialData) {
            setFormData({
                licensePlate: initialData.licensePlate || '',
                brand: initialData.brand || '',
                model: initialData.model || '',
                year: initialData.year || new Date().getFullYear(),
                color: initialData.color || '',
                chassis: initialData.chassis || '',
                type: initialData.type || 'CAR',
            });
        }
    }, [initialData]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
        // Clear error when user types
        if (errors[name]) {
            setErrors(prev => ({ ...prev, [name]: null }));
        }
    };

    const handleSubmit = async () => {
        setIsSubmitting(true);
        setErrors({});
        try {
            await onSubmit(formData);
        } catch (error) {
            if (error.exceptionDetails) {
                const newErrors = {};
                error.exceptionDetails.forEach(detail => {
                    // Extract field name from location (e.g., "Vehicle.licensePlate" -> "licensePlate")
                    const field = detail.location.split('.').pop();
                    newErrors[field] = detail.reason;
                });
                setErrors(newErrors);
            } else {
                setMessageModal({
                    open: true,
                    title: 'Erro',
                    message: error.message || 'Ocorreu um erro ao salvar.',
                });
            }
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <>
            {messageModal.open && (
                <MessageModal
                    title={messageModal.title}
                    message={messageModal.message}
                    onClose={() => setMessageModal((m) => ({ ...m, open: false }))}
                />
            )}
            <CrudForm
            title={initialData ? 'Editar Veículo' : 'Novo Veículo'}
            onSubmit={handleSubmit}
            onCancel={onCancel}
            isSubmitting={isSubmitting}
        >
            <FormRow>
                <FormGroup>
                    <label htmlFor="model">Modelo *</label>
                    <Input
                        id="model"
                        name="model"
                        value={formData.model}
                        onChange={handleChange}
                        required
                        $hasError={!!errors.model}
                        title={errors.model}
                    />
                </FormGroup>
                <FormGroup>
                    <label htmlFor="brand">Marca *</label>
                    <Input
                        id="brand"
                        name="brand"
                        value={formData.brand}
                        onChange={handleChange}
                        required
                        $hasError={!!errors.brand}
                        title={errors.brand}
                    />
                </FormGroup>
            </FormRow>

            <FormRow>
                <FormGroup>
                    <label htmlFor="licensePlate">Placa *</label>
                    <Input
                        id="licensePlate"
                        name="licensePlate"
                        value={formData.licensePlate}
                        onChange={handleChange}
                        required
                        $hasError={!!errors.licensePlate}
                        title={errors.licensePlate}
                    />
                </FormGroup>
                <FormGroup>
                    <label htmlFor="color">Cor *</label>
                    <Input
                        id="color"
                        name="color"
                        value={formData.color}
                        onChange={handleChange}
                        required
                        $hasError={!!errors.color}
                        title={errors.color}
                    />
                </FormGroup>
            </FormRow>

            <FormRow>
                <FormGroup>
                    <label htmlFor="year">Ano</label>
                    <Input
                        id="year"
                        name="year"
                        type="number"
                        value={formData.year}
                        onChange={handleChange}
                        $hasError={!!errors.year}
                        title={errors.year}
                    />
                </FormGroup>
                <FormGroup>
                    <label htmlFor="type">Tipo *</label>
                    <Select
                        id="type"
                        name="type"
                        value={formData.type}
                        onChange={handleChange}
                        required
                        $hasError={!!errors.type}
                        title={errors.type}
                    >
                        {VEHICLE_TYPES.map(type => (
                            <option key={type.value} value={type.value}>
                                {type.label}
                            </option>
                        ))}
                    </Select>
                </FormGroup>
            </FormRow>

            <FormGroup>
                <label htmlFor="chassis">Chassis</label>
                <Input
                    id="chassis"
                    name="chassis"
                    value={formData.chassis}
                    onChange={handleChange}
                    $hasError={!!errors.chassis}
                    title={errors.chassis}
                />
            </FormGroup>
        </CrudForm>
        </>
    );
}
